export const IGNORE_PAYMENT_PARTNER_FIELDS = {
  fieldGroupId: 'ignorePaymentPartnerGroup',
  descriptionHeaderKey: 'ignorePaymentPartnerDescriptionHeader',
  descriptionBodyKey: 'ignorePaymentPartnerDescription',
  fieldDefinitions: [
    {
      type: 'select-many',
      name: 'ignorePaymentPartnerOption',
      options: {
        type: 'select-many',
        selectables: [
          {
            key: 'ignorePaymentPartner',
            value: 'ignorePaymentPartner',
            conflicts: null,
            type: 'radio',
            options: null,
            expandable: {
              fieldGroupId: 'ignorePaymentPartnerExpandable',
              fieldDefinitions: [
                {
                  type: 'include',
                  name: 'ignorePaymentPartnerList',
                  options: null,
                  gridCol: 12,
                  index: 99,
                  required: true,
                  hidden: false,
                },
              ],
              index: 99,
            },
          },
        ],
      },
      gridCol: 12,
      index: 99,
      required: false,
      hidden: false,
    },
  ],
  index: 99,
};
